import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const WorkspacesHaug = HelpVideo(
    'WorkspacesHaug',
    'Dashboard / Workspaces',
    'Workspaces',
    2030,
    'https://s.metroretro.io/app/haug/02020-workspaces.mp4',
);
